export const accordions = (items) => {
  items.forEach((item) => {
    let active = false;
    const trigger = item.querySelector(item.dataset.trigger);
    const target = item.querySelector(item.dataset.target);
    const targetHeight = target.offsetHeight;
    target.style.height = 0;
    item.classList.add('js-init');

    trigger.addEventListener('click', () => {
      if (!active) {
        item.classList.add('js-active');
        target.style.height = `${targetHeight}px`;
      } else {
        item.classList.remove('js-active');
        target.style.height = 0;
      }
      active = !active;
    });
  });
};
